import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ElevenLabsWidget from './components/ElevenLabsWidget';
import Admin from './components/Admin';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/admin" element={<Admin />} />
        {/* DB-backed and config-backed survey links share this route */}
        <Route path="/:projectId" element={<ElevenLabsWidget />} />
        <Route
          path="*"
          element={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100dvh',
                backgroundColor: '#F7F5F2',
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
              }}
            >
              <div style={{ textAlign: 'center', color: '#1A1A1A' }}>
                <h1 style={{ fontSize: 22, marginBottom: 8 }}>Page not found</h1>
                <a href="/admin" style={{ color: '#E85D04' }}>
                  Go to admin
                </a>
              </div>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
